<template lang='pug' src='./dentist-in-city.pug'></template>

<script>
import Hero from 'components/hero/hero-dentist-in-city/hero-dentist-in-city'
import Loader from 'components/loader/loader'
import { openModal } from '@/methods'

export default {
  name: 'Dentist In City',
  computed: {
    props () {
      return this.$store.state.pages['dentist-in-city']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  mixins: [ openModal ],
  components: {
    Hero,
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// dentist-in-city.vue?ec792f96